import React, { useState, useContext, useEffect } from "react";
import "./claimintake.css";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
import { UserContext } from '../../stores/Context/Context'
import { Trash2, UploadCloud } from "react-feather";
import Dropzone from "react-dropzone";
import style from "./uploadDocuments.module.css"
import { toast } from "react-toastify";
import { claimUploadDocumentsData } from "../../stores/slices/claimIntake/claimIntakeSlice";
import { documentValidation,areNamesUnique, fileSizeValidation } from "../../utilities/validations/documentValidation";

// drag drop file component
function UploadDocuments() {
  let wizardValidation = useContext(UserContext);
  const [files, setFiles] = useState([]);

  const selectedLanguage = useSelector(language).Claimintake.documents;
  const uploadedDocuments = useSelector(state => state.claimIntakeSlice.uploadedDocuments)
  const claimProcessData = useSelector(state => state.claimProcessSlice)
  const dispatch = useDispatch()

  useEffect(() => {
    setFiles(uploadedDocuments)
  }, [])

  function uploadDocumentsValidation() {
    if (files.length > 0) {
      let tempArr = []
      files.map((file) => {
        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => {
          let base64 = reader.result.split(",");
          let ext = /(?:\.([^.]+))?$/;
          let fileExt = ext.exec(file.name)[1];
          let fileName = file.name.split('.').slice(0, -1).join('.');
          let cleanName = fileName.replace(/["*:\|/?<>]/g, '');
          cleanName =cleanName.trim().split(" ").join("").substring(0, 41)
          cleanName=cleanName+new Date().toISOString().split("T")[0]+Math.floor(Math.random() * 100 + 1);
          let today = new Date();
          let dd = String(today.getDate()).padStart(2, '0');
          let mm = String(today.getMonth() + 1).padStart(2, '0');
          let yyyy = today.getFullYear()
          let date = yyyy + mm + dd

          let data = [{
            "File_Type": "Claim",
            "FileTypeCode": "782",
            "pxObjClass": "Embed-DragDropFile",
            "pyCategory": "File",
            "pyFileName": cleanName.trim().split(" ").join("").substring(0, 54) + '.' + fileExt,
            "pyFileSource": base64[1],
            "pyFileType": fileExt,
            "pyNote": cleanName.trim().split(" ").join("").substring(0, 54),
            "ReceptionDate": date,
            "ApplicationID": claimProcessData.applicationID,
            "AssociatedApplications": [
              {
                "ApplicationID": claimProcessData.applicationID
              }
            ],
            "Categories": [
              {
                "FileCategory": 'General',
                "FileCategoryCode": "DC6",
                "FileCategoryID": "788",
                "pxObjClass": "SingleValue-Text"
              }
            ]
          }]

          tempArr = [...tempArr, ...data]
          dispatch(claimUploadDocumentsData({ tempArr, files }))
        }
      })
      return true
    } else {
      toast.error("Please upload supporting documentation to continue")
      return false
    }
  }

  wizardValidation.formValidation.isValidate = uploadDocumentsValidation;

  const onDrop = (acceptedFiles, rejectedFiles) => {
    let isProtected = [];
    const validFileExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".heif"];
    if (rejectedFiles.length > 0) {
      toast.error('Document file size exceeds 10MB limit')
    }

    let isValidFile = false;
    let valid = [];
    acceptedFiles.forEach((file, i) => {
      if (file?.name != "") {
        validFileExtensions.find((validFileExtension) => {
          if (file.name.includes(validFileExtension)) {
            isValidFile = true
            return true
          } else {
            isValidFile = false
          }
        })
        if (isValidFile) {
          const reader = new FileReader()
          reader.onload = (e) => {
            const int32View = new Uint8Array(e.target.result);
            isProtected.push(`${documentValidation(int32View)}`);
            if (
              (int32View.length > 4 && int32View[0] == 0xFF && int32View[1] == 0xD8 && int32View[2] == 0xFF && int32View[3] == 0xE0) || //jpg/jpeg
              (int32View.length > 4 && int32View[0] == 0x89 && int32View[1] == 0x50 && int32View[2] == 0x4E && int32View[3] == 0x47) || //png
              (int32View.length > 4 && int32View[0] == 0x25 && int32View[1] == 0x50 && int32View[2] == 0x44 && int32View[3] == 0x46) || //pdf 
              (int32View.length > 4 && int32View[0] == 0x0 && int32View[1] == 0x0 && int32View[2] == 0x0 && int32View[3] == 0x18) //heif
            ) {
              isValidFile = true;
              valid.push('true')
              // setFiles([...files, ...acceptedFiles])
            } else {
              isValidFile = false;
            }
          }
          reader.readAsArrayBuffer(file)
        } else {
          return false;
        }
      }
    })
    setTimeout(() => {
      let resultDoc = isProtected.every(value => value === 'true');
      let isNameValidations =  areNamesUnique(files,acceptedFiles);
      let fileSizeValid=fileSizeValidation(files,acceptedFiles)
      if (valid.length == acceptedFiles.length && resultDoc && fileSizeValid && isNameValidations) {
        setFiles([...files, ...acceptedFiles])
        dispatch(claimUploadDocumentsData({ tempArr: [], files: [...files, ...acceptedFiles] }))

      } else {
        if(!fileSizeValid){
          toast.error("Upload exceeds 15MB limit");
          return false  
        }else{
        if(!isNameValidations){
          toast.error("The document was not uploaded successfully. Please check the name of your file and try again.");
          return false
        }else{
          if(!resultDoc){
            toast.error("Error: Invalid file. Please remove password-protection and reupload the document.");
            return false;
          }else{
            toast.error("File type invalid, unable to upload");
            return false;
          }
        }
      }
      }
    }, 500);
  }

  const removeImage = (e, i,file) => {
    e.preventDefault()
    let UploadDocuments_copy = [...files]
    UploadDocuments_copy.splice(i, 1);
    // UploadDocumentsClaims.splice(i, 1);
    setFiles(UploadDocuments_copy)
    dispatch(claimUploadDocumentsData({ tempArr:UploadDocuments_copy, files: UploadDocuments_copy }))

  }

  return (
    <>
    <div className={style.uploadDocumentHeader}>
      <h3>Please upload supporting documentation</h3>
      <div className="document_header">To ensure your document is uploaded successfully, please ensure the file name is unique and does not contain any special characters.<br></br> Example of correct format: John Doe Income 1.1.25</div>
    </div>
    <Dropzone maxSize="10485760" onDrop={onDrop}>
      {({ getRootProps, getInputProps, isDragReject }) => (
        <section className="mt-5 px-8">
          <div  {...getRootProps({ className: `dropzone ${files && files.length > 0 ? 'disabled' : ''}}` })}>
            <input {...getInputProps()} />
            <div className="side-menu__icon yellow d-flex justify-content-center">
              <UploadCloud className="h-12 w-6" />
            </div>
            <p>{selectedLanguage.uploadFile}</p>
          </div>
          <p className="pt-1" style={{ fontSize: 10 }}><i>* Maximum File Size is 10MB Per File. Attachments Cannot Exceed 15MB Total. Acceptable File Formats: PDF, JPEG, JPG, PNG, HEIF</i></p>
          {isDragReject && "File type not accepted, sorry!"}
          <aside className={style.dz_files}>
            {files.map((file, index) => (
              <div className={`${style.dz_preview} ${style.dz_preview_border} px-2 py-1`} key={file.name} onClick={(e) => removeImage(e, index,file)}>
                <div className={`${style.dz_image} d-flex justify-content-end color-danger`}><Trash2 /> </div>
                <div className={style.dz_details}>
                  <div className={style.dz_size}><span  ><strong>{Math.round(file.size / 1024)}</strong> KB</span></div>
                  <div className={style.dz_filename}><span  >{file.name}</span></div>
                </div>
              </div>
            ))}
          </aside>
        </section>
      )}
    </Dropzone>
    </>
  );
}

export default UploadDocuments;
